/*eslint-disable*/
import React, {PureComponent} from 'react'
import Promise from 'bluebird'
import Notifier from 'react-notify'
import Spinner from 'react-spinkit'
import checkServerResponse from '../utils/ServerResponses'
import SearchParams from '../components/SearchParams'
import Results from '../components/Results'
import errorReport from '../utils/errorReport';
import {getData, getSearchBoxOptions} from '../utils/api';

const USER_CREATED = "Select-create-option-placeholder",
  SEARCH = "Search",
  CONTRACT_KEY = "gen_contractnumber_tb", // the column name to display
  CONTRACT_SEARCH = `${CONTRACT_KEY}${SEARCH}`, // the column name to search for (lower case string from db)
  VENDOR_KEY = "gen_vendorname_tb",
  VENDOR_SEARCH = `${VENDOR_KEY}${SEARCH}`,
  PROJECT_KEY = "gen_projectid_tb",
  PROJECT_SEARCH = `${PROJECT_KEY}${SEARCH}`,
  initialState = {
    search: false,
    loading: false,
    [VENDOR_KEY]: null,
    [CONTRACT_KEY]: null,
    [PROJECT_KEY]: null,
    data: []
  },
  LABEL = 'label',
  VALUE = 'value';

export default class ProjContractDash extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.vendorInputChange = this.inputChange.bind(this, VENDOR_KEY);
    this.projectInputChange = this.inputChange.bind(this, PROJECT_KEY);
    this.contractInputChange = this.inputChange.bind(this, CONTRACT_KEY);
    this.cancelSearch = undefined;
    this.cancelSearchOptions = undefined;
  }


  componentDidMount() {
    this.run()
  }

  toggleLoading = () => {
    return Promise.resolve()
      .then(() => {
        this.setState({
          loading: !this.state.loading
        })
      })
  };

  /**
   *
   * @param {string} [type=error,info,success]
   * @param title
   * @param message
   * @param duration 4 seconds
   */
  notify = (type='info',title,message,duration=4000)=>{
    this.Notifier[type](title,message,duration);
  };

  checkResponse = (res)=>{
    const {status,data} = res;
    const {value} = data;
    const {type,message} = checkServerResponse(status);
    if(type !== 'success'){
      this.notify(type, `Server ${type}`, message);
    }
    return value;
  };

  sendOptions = (options=[])=>{
    return {options};
  };

  noOptions = () => {
    return Promise.resolve([]);
  };

  vendorSearch = (q)=>{
    return this.getOptions('v',q);
  };

  contractSearch = (q)=>{
    return this.getOptions('c',q);
  };

  projectSearch = (q)=>{
    return this.getOptions('p',q);
  };

  /**
   * Returns options for search inputs, all options are
   * @param zType [p,c,v]
   * @param q Search query
   * @returns {Promise.<any>}
   */
  getOptions = (zType,q)=>{
    if(!q) return this.noOptions();
    let {
      [VENDOR_KEY]:  vendorFilter,    // Vendor Search Input Selected Value
      [PROJECT_KEY]: projectFilter,   // Project Search Input Selected Value
      [CONTRACT_KEY]: contractFilter   // Contract Input Selected Value
    } = this.state;

    // assign default values or destructure value and rename
    !vendorFilter ? vendorFilter = '%' : {value: vendorFilter} = vendorFilter;
    !projectFilter ? projectFilter = '%' : {value: projectFilter} = projectFilter;
    !contractFilter ? contractFilter = '%' : {value: contractFilter} = contractFilter;

    switch (zType){
      case 'p': projectFilter = q;
      break;
      case 'v': vendorFilter = q;
      break;
      case 'c': contractFilter = q;
      break;
      default: return this.noOptions();
    }
    const data = {
        zType,
        contractFilter,
        projectFilter,
        vendorFilter
      };

    if(this.cancelSearchOptions){
      this.cancelSearchOptions();
    }
    const {cancel,request} = getSearchBoxOptions(data);
    this.cancelSearchOptions = cancel;
    return request
    .then(this.checkResponse)
    .then(this.sendOptions)
    .catch((err)=>{
      if(err.constructor.name !== 'Cancel'){
        errorReport(err);
        this.notify('error','Search Error', err.message)
      }
    })
    .finally(() => {
      this.cancelSearchOptions = undefined;
    })
  };

  inputChange(name,value){
    this.setState({
      [name]: value
    },this.run)
  }

  reset = () => {
    this.setState(initialState)
  };

  run = () => {
    return this.toggleLoading()
      .then(this.getData)
      .then(this.checkResponse)
      .then((data)=>{
        this.setState({
          search: true,
          data
        })
      })
      .catch((err)=>{
        if(err.constructor.name !== 'Cancel'){
          errorReport(err);
          this.notify('error','Error',err.message);
        }
      })
      .finally(this.toggleLoading)
  };

  createFilter = () => {
    const {
      [VENDOR_KEY]:vendorSearchInput,    // Vendor Search Input Selected Value
      [PROJECT_KEY]:projectSearchInput,  // Project Search Input Selected Value
      [CONTRACT_KEY]:contractSearchInput // Contract Input Selected Value
    } = this.state,
    ORDER_BY = `${CONTRACT_KEY},${PROJECT_KEY},poRecordNo`,
    params = [];
    // Create filter with no search inputs entered
    if(!vendorSearchInput && !projectSearchInput && !contractSearchInput){
      return {$top:250,$orderby:'poID desc'};
    }

    // Add filter params based on inputs
    if(vendorSearchInput) {
        filter(params,VENDOR_SEARCH,vendorSearchInput[VALUE],vendorSearchInput.className);
    }
    if(projectSearchInput) {
      filter(params,PROJECT_SEARCH,projectSearchInput[VALUE],projectSearchInput.className,'gen_projectname_spnSearch');
    }
    if(contractSearchInput) {
      filter(params,CONTRACT_SEARCH,contractSearchInput[VALUE],contractSearchInput.className);
    }
    return {
      $filter: params.join(' and '),
      $orderby: ORDER_BY
    };
  };

  getData = ()=>{
    const params = this.createFilter();
    // cancel running search;
    if(this.cancelSearch) {
      this.cancelSearch();
    }
    const {cancel,request} = getData(params);
    this.cancelSearch = cancel;
    return request
      .finally(() => {
        this.cancelSearch = undefined;
      })
  };

  render() {
    const {
        vendorSearch, projectSearch, contractSearch, run, reset,
        state: {loading, search, data, [VENDOR_KEY]: vendorValue, [PROJECT_KEY]: projectValue, [CONTRACT_KEY]: contractValue}
      } = this;
    return (
      <div>
        <SearchParams
          vendorInputChange={this.vendorInputChange}
          projectInputChange={this.projectInputChange}
          contractInputChange={this.contractInputChange}
          vendorSearch={vendorSearch}
          projectSearch={projectSearch}
          contractSearch={contractSearch}
          LABEL={LABEL}
          VALUE={VALUE}
          vendorValue={vendorValue}
          projectValue={projectValue}
          contractValue={contractValue}
          run={run}
          reset={reset}
        />
        <ComponentToRender loading={loading} search={search} data={data}/>
        <Notifier ref={ ref => this.Notifier = ref }/>
      </div>
    );
  }
}

const ComponentToRender = ({loading,search,data,...rest}) => {
  if(loading) return <div className="col-lg-2 col-lg-offset-6"><Spinner spinnerName="folding-cube"/></div>;
  if(data.length) return <Results {...{data}} {...rest}/>;
  if(search && !data.length) return <span className="text-center"><h3>No Data</h3><p>No data using parameters, please retry.</p></span>;
  return <span/>;
};
/**
 * Create OData Filter
 * @param {Array} params
 * @param {String} column
 * @param {String} value
 * @param {String} className
 * @param {String} [other] Secondary column name to search for if search input is user created
 */
const filter = (params,column,value,className,other)=>{
  if(className === USER_CREATED){
    params.push(`contains(${other || column},"${value.toLowerCase()}")`)
  } else {
    params.push(`${column} eq "${value.toLowerCase()}"`);
  }
};


// WEBPACK FOOTER //
// ./src/containers/index.jsx